/** How money is received or paid — one list and one set of names, everywhere. */
export const PAYMENT_METHODS = ['cash', 'bank_transfer', 'cheque', 'online'] as const;
export type PaymentMethod = typeof PAYMENT_METHODS[number];

export const PAYMENT_METHOD_LABEL: Record<PaymentMethod | 'adjustment', string> = {
  cash: 'Cash',
  bank_transfer: 'Bank transfer',
  cheque: 'Cheque',
  online: 'Online',
  adjustment: 'Adjustment',   // ledger-only: manual entries
};

export const PAYMENT_METHOD_OPTIONS = PAYMENT_METHODS.map(value => ({ value, label: PAYMENT_METHOD_LABEL[value] }));
